export const SortByFieldSmart = (data: any[], field: string): any[] =>
  [...data].sort((a, b) => {
    const aVal = a[field];
    const bVal = b[field];

    const aNum = Number(aVal);
    const bNum = Number(bVal);

    const aIsNum = !isNaN(aNum);
    const bIsNum = !isNaN(bNum);

    if (aIsNum && bIsNum) {
      return aNum - bNum;
    } else if (aIsNum) {
      return -1;
    } else if (bIsNum) {
      return 1;
    } else {
      return String(aVal).localeCompare(String(bVal), "fa");
    }
  });